export default "__VITE_ASSET__DQQ$KQcX__"